import { TLLBoardActions } from './ll-board.actions';
import { TLLBoardInfoActionType, TLLBoardState } from './ll-board.models';

export const initialState: TLLBoardState = {
  lineShiftInfo: null,
  llBoardList: null,
  loadStripOnMouse: null,
  llTaskManager: null,
  learningCurveStripInfo: null,
  learningCurveByFactoryOtl: null,
  lineStripListingInfo: null,
  lineStripPlannedNumbers: null,
  llPCDPEDThreshold: null,
};

export function llBoardReducer(state = initialState, action: TLLBoardActions): TLLBoardState {
  switch (action.type) {
    case TLLBoardInfoActionType.GetLLBoardListSuccess:
      return {
        ...state,
        llBoardList: action.payload,
      };
    case TLLBoardInfoActionType.GetLineShiftInfo:
      return {
        ...state,
        lineShiftInfo: null,
      };
    case TLLBoardInfoActionType.GetLineShiftInfoSuccess:
      return {
        ...state,
        lineShiftInfo: action.lineShiftRes,
      };
    case TLLBoardInfoActionType.SetLoadStripOnMouse:
      return {
        ...state,
        loadStripOnMouse: action.loadStrip,
      };

    case TLLBoardInfoActionType.GetLLBoardTaskManagerSuccess:
      return {
        ...state,
        llTaskManager: action.res,
      };
    case TLLBoardInfoActionType.GetLearningCurveStripeInfoSuccess:
      return {
        ...state,
        learningCurveStripInfo: action.learningCurveStripRes,
      };
    case TLLBoardInfoActionType.GetLearningCurveByFactoryOtlSuccess:
      return {
        ...state,
        learningCurveByFactoryOtl: action.learningCurveFactoryOtlRes,
      };
    case TLLBoardInfoActionType.GetLineStripListingSuccess:
      return {
        ...state,
        lineStripListingInfo: action.lineStripListingRes,
      };
    case TLLBoardInfoActionType.LineStripPlannedNumbersSuccess:
      return {
        ...state,
        lineStripPlannedNumbers: action.stripPlannedNumbers,
      };
    case TLLBoardInfoActionType.SetLLPCDPEDThreshold:
      return {
        ...state,
        llPCDPEDThreshold: action.addPCDPEDThresholds,
      };
    default:
      return state;
  }
}
